/**
 * gateTestBypass — a SAFE developer switch to skip the public rate-gate
 * (email + reCAPTCHA) so the results layout can be driven in automated/browser
 * testing without solving a CAPTCHA.
 *
 * Deliberately powerless in production. It takes effect only when BOTH:
 *   (a) the URL carries `?rgtest=1`, AND
 *   (b) the host is a KNOWN non-prod host — localhost, or a Netlify deploy/branch
 *       preview (contains `--` before `.netlify.app`).
 * A positive allowlist (not "anything but prod") so an alternate production
 * hostname — including the bare `sitename.netlify.app` alias — can never enable
 * it. On the real domain it always returns false and the gate stands.
 */
const isNonProdHost = (hostname) => {
  const h = String(hostname || '');
  if (h === 'localhost' || h === '127.0.0.1') return true;
  // Deploy previews / branch deploys are `deploy-preview-N--site` / `branch--site`
  // (the `--` distinguishes them from the prod `site.netlify.app` alias).
  return h.endsWith('.netlify.app') && h.includes('--');
};

/**
 * @param {{search?:string, hostname?:string}} [loc] defaults to window.location
 * @returns {boolean}
 */
export const isGateTestBypass = (loc) => {
  const src = loc || (typeof window !== 'undefined' ? window.location : null);
  if (!src) return false;
  const { search, hostname } = src;
  if (!/[?&]rgtest=1(?:&|$)/.test(search || '')) return false;
  return isNonProdHost(hostname);
};
